(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbs-retail-shelf"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbs-retail-shelf')) {
  customElements.define('tbs-retail-shelf', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      const api = this.dataset.api;
      const key = this.dataset.key;
      if (!api || !key) return;

      const request = async (path) => {
        const response = await fetch(api + path, {
          headers: { apikey: key, Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('shelf-unavailable');
        return response.json();
      };

      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.dataset.currency || 'USD'
      });

      const tierOrder = { FREE: 10, POWER: 20, PASS30: 30, HIGHER: 40, PRO: 50, WORKFORCE: 60, ENTERPRISE: 70 };

      try {
        const flags = await request(
          '/rest/v1/tbs_runtime_flags?flag_key=eq.retail_standard_visible&select=enabled&limit=1'
        );
        if (!flags[0] || flags[0].enabled !== true) return;

        const results = await Promise.all([
          request('/rest/v1/tbs_bot_registry?status=in.(ACTIVE,PREVIEW)&select=bot_slug,shopify_handle,one_line_job,primary_cta'),
          request('/rest/v1/tbs_bot_price_map?enabled=eq.true&select=bot_slug,tier_key,price_cents,customer_label')
        ]);

        const bots = results[0] || [];
        const prices = results[1] || [];
        const byHandle = new Map(bots.map((bot) => [bot.shopify_handle, bot]));
        const pricesByBot = new Map();

        for (const price of prices) {
          if (!pricesByBot.has(price.bot_slug)) pricesByBot.set(price.bot_slug, []);
          pricesByBot.get(price.bot_slug).push(price);
        }

        for (const list of pricesByBot.values()) {
          list.sort((a, b) => (tierOrder[a.tier_key] || 999) - (tierOrder[b.tier_key] || 999));
        }

        const cards = document.querySelectorAll('[data-product-handle]');
        for (const card of cards) {
          if (card.querySelector('.tbs-shelf-cue')) continue;

          const handle = card.dataset.productHandle;
          const bot = byHandle.get(handle);
          if (!bot) continue;

          const content =
            card.querySelector('.product-card__content') ||
            card.querySelector('.resource-card__content') ||
            card;

          const cue = document.createElement('div');
          cue.className = 'tbs-shelf-cue';

          const badge = document.createElement('span');
          badge.className = 'tbs-shelf-cue__badge';
          badge.textContent = this.dataset.badge || 'BOT SPECIALIST';

          const job = document.createElement('p');
          job.className = 'tbs-shelf-cue__job';
          job.textContent = bot.one_line_job || '';

          const access = document.createElement('div');
          access.className = 'tbs-shelf-cue__access';

          const list = pricesByBot.get(bot.bot_slug) || [];
          const visiblePrices = list.slice(0, 3);

          if (visiblePrices.length) {
            for (const price of visiblePrices) {
              const pill = document.createElement('span');
              pill.className = 'tbs-shelf-cue__pill';
              const label = price.customer_label || price.tier_key;
              const amount = Number(price.price_cents || 0);
              pill.textContent = amount === 0 ? label : label + ' · ' + money.format(amount / 100);
              access.append(pill);
            }
          } else if (bot.primary_cta) {
            const pill = document.createElement('span');
            pill.className = 'tbs-shelf-cue__pill';
            pill.textContent = bot.primary_cta;
            access.append(pill);
          }

          cue.append(badge, job, access);
          content.append(cue);
        }
      } catch (error) {
        return;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbs-retail-standard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbs-retail-standard')) {
  customElements.define('tbs-retail-standard', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      const api = this.dataset.api;
      const key = this.dataset.key;
      const handle = this.dataset.handle;
      if (!api || !key || !handle) return;

      const request = async (path) => {
        const response = await fetch(api + path, {
          headers: { apikey: key, Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('retail-standard-unavailable');
        return response.json();
      };

      try {
        const flagRows = await request(
          '/rest/v1/tbs_runtime_flags?flag_key=eq.retail_standard_visible&select=enabled&limit=1'
        );
        if (!flagRows[0] || flagRows[0].enabled !== true) {
          this.remove();
          return;
        }

        const botRows = await request(
          '/rest/v1/tbs_bot_registry?shopify_handle=eq.' +
            encodeURIComponent(handle) +
            '&select=bot_slug,display_name,one_line_job,outcome_promise,free_experience_summary,primary_cta,status&limit=1'
        );
        const bot = botRows[0];
        if (!bot) return;

        const results = await Promise.all([
          request(
            '/rest/v1/tbs_bot_trust_cards?bot_slug=eq.' +
              encodeURIComponent(bot.bot_slug) +
              '&select=can_do,asks_first,never_does,customer_control_line&limit=1'
          ),
          request(
            '/rest/v1/tbs_bot_price_map?bot_slug=eq.' +
              encodeURIComponent(bot.bot_slug) +
              '&enabled=eq.true&select=tier_key,price_cents,customer_label,trigger_rule'
          )
        ]);

        const trust = results[0][0];
        const prices = results[1] || [];
        const order = { FREE: 10, POWER: 20, PASS30: 30, HIGHER: 40, PRO: 50, WORKFORCE: 60, ENTERPRISE: 70 };
        prices.sort((a, b) => (order[a.tier_key] || 999) - (order[b.tier_key] || 999));

        this.querySelector('.tbs-retail-standard__name').textContent = bot.display_name || '';
        this.querySelector('.tbs-retail-standard__job').textContent = bot.one_line_job || '';
        this.querySelector('.tbs-retail-standard__outcome').textContent = bot.outcome_promise || '';
        this.querySelector('.tbs-retail-standard__free-copy').textContent = bot.free_experience_summary || '';
        this.querySelector('.tbs-retail-standard__cta').textContent = bot.primary_cta || '';

        const access = this.querySelector('.tbs-retail-standard__access');
        const priceRoot = this.querySelector('.tbs-retail-standard__prices');
        if (!prices.length) {
          access.hidden = true;
        } else {
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.dataset.currency || 'USD'
          });
          for (const price of prices) {
            const row = document.createElement('div');
            row.className = 'tbs-retail-standard__price';

            const name = document.createElement('span');
            name.className = 'tbs-retail-standard__price-name';
            name.textContent = price.customer_label || price.tier_key;

            const value = document.createElement('span');
            value.className = 'tbs-retail-standard__price-value';
            value.textContent = formatter.format(Number(price.price_cents || 0) / 100);

            const trigger = document.createElement('p');
            trigger.className = 'tbs-retail-standard__price-trigger';
            trigger.textContent = price.trigger_rule || '';

            row.append(name, value, trigger);
            priceRoot.append(row);
          }
        }

        const fillList = (selector, values) => {
          const root = this.querySelector(selector);
          for (const value of values || []) {
            const item = document.createElement('li');
            item.textContent = value;
            root.append(item);
          }
        };

        if (trust) {
          fillList('.tbs-retail-standard__can', trust.can_do);
          fillList('.tbs-retail-standard__asks', trust.asks_first);
          fillList('.tbs-retail-standard__never', trust.never_does);
          this.querySelector('.tbs-retail-standard__control').textContent = trust.customer_control_line || '';
        } else {
          this.querySelector('.tbs-retail-standard__trust').hidden = true;
        }

        const main = document.querySelector('#MainContent');
        const firstSection = main ? main.querySelector(':scope > .shopify-section') : null;
        if (firstSection && firstSection !== this) firstSection.after(this);

        this.hidden = false;
      } catch (error) {
        this.remove();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
